import type { Perspective } from "@/mocks/events";

const sideColor = [
  "border-primary-300 bg-primary-50",
  "border-accent-300 bg-accent-50",
  "border-secondary-300 bg-secondary-50",
  "border-background-300 bg-background-100",
];

export default function PerspectivesBlock({ perspectives }: { perspectives: Perspective[] }) {
  return (
    <section id="sec-perspectives" className="scroll-mt-20">
      <h2 className="flex items-center gap-2.5 font-heading text-xl font-black text-foreground-950 md:text-2xl">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
          <i className="ri-scales-3-line" aria-hidden="true"></i>
        </span>
        各方观点光谱
      </h2>
      <p className="mt-2 text-sm text-foreground-600">
        把不同立场的公开表态分列，冲突点通常不是「谁在说谎」，而是诉求不同。
      </p>

      <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
        {perspectives.map((p, i) => (
          <div
            key={p.side}
            className={`rounded-lg border-l-4 p-5 ${sideColor[i % sideColor.length]}`}
          >
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-900">
              <i className="ri-chat-quote-line text-accent-700" aria-hidden="true"></i>
              {p.side}
            </h3>
            <ul className="mt-3 space-y-2">
              {p.points.map((pt) => (
                <li key={pt} className="flex items-start gap-2 text-sm leading-relaxed text-foreground-700">
                  <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-foreground-400"></span>
                  {pt}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}